export default __webpack_public_path__ + "static/media/education3.ad5a0f3b.jpg";